import React, { useCallback, useRef, useState } from "react";
import {
  ReactFlow,
  ReactFlowProvider,
  Background,
  addEdge,
  applyNodeChanges,
  applyEdgeChanges,
  useReactFlow,
  Controls,
  MiniMap,
} from "@xyflow/react";
//@ts-ignore
import "@xyflow/react/dist/style.css";
import Sidebar from "./Sidebar";
import CustomNode from "./Customnode";
import StyledWorkFlow from "./styles";

const nodeTypes = { custom: CustomNode };

let idCounter = 1;
const getId = () => `node_${idCounter++}`;

const initialNodes = [
  {
    id: "node_0",
    type: "custom",
    position: { x: 250, y: 40 },
    data: {
      label: "Message received",
      icon: "ThunderboltOutlined",
      status: "configured",
    },
  },
];

const WorkFlow = () => {
  const wrapperRef = useRef(null);
  const [nodes, setNodes] = useState(initialNodes);
  const [edges, setEdges] = useState([]);
  const { screenToFlowPosition } = useReactFlow();

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
    [],
  );
  const onEdgesChange = useCallback(
    (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
    [],
  );
  const onConnect = useCallback(
    (connection) => setEdges((eds) => addEdge(connection, eds)),
    [],
  );

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }, []);

  const onDrop = useCallback(
    (event) => {
      event.preventDefault();
      const raw = event.dataTransfer.getData("application/reactflow");
      if (!raw) return;
      const item = JSON.parse(raw);

      const position = screenToFlowPosition({
        x: event.clientX,
        y: event.clientY,
      });

      const newNode = {
        id: getId(),
        type: "custom",
        position,
        data: item,
      };

      setNodes((nds) => nds.concat(newNode));
    },
    [screenToFlowPosition],
  );

  return (
    <StyledWorkFlow>
      <div className="w-100 h-100 flex">
        <Sidebar />
        <div className="workflow-div">
          <div ref={wrapperRef} className="ref-div">
            <ReactFlow
              nodes={nodes}
              edges={edges}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onConnect={onConnect}
              onDrop={onDrop}
              onDragOver={onDragOver}
              nodeTypes={nodeTypes}
              // fitView
            >
              <MiniMap />
              <Controls />
              <Background />
            </ReactFlow>
          </div>
        </div>
      </div>
    </StyledWorkFlow>
  );
};

const WorkFlowProvider = () => {
  return (
    <ReactFlowProvider>
      <WorkFlow />
    </ReactFlowProvider>
  );
};

export default WorkFlowProvider;
